import { Component } from '@angular/core';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';

import { ExchangeRateService } from '../services/exchange.rate.service';

import { ExchangeRate } from '../models/exchange.rate.model';
import { NotificationService } from '../services/notification.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-exchange-rate-list',
  templateUrl: './exchange-rate-list.component.html'
})
export class ExchangeRateListComponent {

  constructor(public service: ExchangeRateService, private datepipe: DatePipe, private modalService: NgbModal, private notificationService: NotificationService) { }

  ngOnInit() {
    this.onSearch();
  }

  options: any = { format: 'YYYY-MM-DD' };

  closeResult = '';
  model = new ExchangeRate();
  modelSearch = new ExchangeRate();

  open(content, model) {
    if (model == null)
      model = new ExchangeRate();

    model.effectiveDate = this.datepipe.transform(model.effectiveDate, 'dd/MM/yyyy');

    this.model = Object.assign({}, model);
    this.modalService.open(content, { ariaLabelledBy: 'modal-basic-title' }).result.then((result) => {
      this.closeResult = 'Closed with: ${result}';
    }, (reason) => {
      this.closeResult = 'Dismissed ${this.getDismissReason(reason)}';
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return 'with: ${reason}';
    }
  }

  onArchive(id) {
    if (!confirm('Are you sure?')) {
      return;
    }

    this.service.archive(id).subscribe(
      res => {
        this.notificationService.notifySuccess();
        this.onSearch();
      },
      err => { console.log(err); }
    );

  }

  onSearch() {
    this.service.list = null;
    this.service.currentPage = 1;
    this.service.modelSearch = this.modelSearch;
    this.service.search();
  }
}

